import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback, useRef } from 'react';

export const ValList = ({ parentEntity, parentEntityId, partition, onSelect, valCodeContextMenuItems }) => {
  const module = useModuleFromRoute();
  const rsrc = useRsrc();

  const augFieldDefs = (fieldToFieldDef) => {
    // Clone some fields and override everything else
    const severityFieldDef = { ...fieldToFieldDef.severity };
    const entityFieldDef = { ...fieldToFieldDef.entity };
    ObjUtils.clearObj(fieldToFieldDef);

    if (onSelect) {
      fieldToFieldDef.checkbox = GridConstants.checkbox;
    }

    // TODO: Cell renderers will be broken - brought from old UI
    fieldToFieldDef.code = { field: 'code', displayName: 'Code', minWidth: 125, autoGrouping: true, rowGroup: true };
    fieldToFieldDef.msg = {
      field: 'msg',
      displayName: 'Error Message',
      minWidth: 300,
      ...(parentEntity === 'INCTV_RBT' ? { cellRenderer: 'valMsgCellRenderer' } : {}),
    };
    fieldToFieldDef.severity = severityFieldDef;
    fieldToFieldDef.entity = entityFieldDef;
    // Named entityId so the grid derives the entityCode display column and uses the numeric entityId as
    // the hyperlink target; naming it entityCode makes the code itself the target id (bigint = varchar).
    fieldToFieldDef.entityId = {
      field: 'entityId',
      displayName: 'Entity',
      module: module,
      type: 'HYPERLINK',
      precedence: 100,
    }; // display name gets appended with 'Code'
  };

  const clientSideRowData = useCallback((setDataSource) => {
    const reqParam = {
      ids: [parentEntityId],
      partition: partition,
      entity: parentEntity,
    };
    rsrc.data(module, 'VAL_DATA_PLUGIN', reqParam, parentEntity).then((res) => {
      setDataSource(res);
    });
  }, []);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
  };

  const entityListRef = useRef();
  const getContextMenuItems = (params) => {
    let contextMenus = entityListRef.current.getContextMenuItems(params);

    if (valCodeContextMenuItems) {
      const row = params?.node?.data;
      const custom = valCodeContextMenuItems(row) ?? [];
      contextMenus = [...contextMenus, ...custom];
    }

    return contextMenus;
  };

  const entityListProps = {
    entity: 'VAL',
    augTabButtons,
    clientSideRowData,
    augFieldDefs,
    gridOptions: {
      treeData: true,
      defaultExpandLevel: 0,
      rowSelection: 'single',
      getContextMenuItems,
    },
  };

  if (onSelect) {
    entityListProps.events = {
      onSelectionChanged: (event) => {
        const rows = event.api.getSelectedRows();
        onSelect(rows[0]);
      },
    };
  }

  return <EntityList ref={entityListRef} {...entityListProps} />;
};
